export class GetGroup {
  public static readonly type = '[Group] GetGroup';
  constructor(public readonly id: string) {}
}
